module.exports = __webpack_public_path__ + "img/app0201.591586df.png";